import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: zhaopu
 * @Date: 2022-02-15 15:32:01
 * @LastEditors: zhaopu
 * @LastEditTime: 2022-02-16 11:37:35
 * @Description: 保障计划列表展示
 */
import React, { useEffect, useState, useReducer } from 'react';
import { Button, Popup } from 'zarm';
import { findModuleFromState } from '@/utils/utils.js';
import PlanSelectPreview from '../PlanSelectPreview';
import InsurancePlanDesc from '@/components/InsurancePlanDesc';
import useStore from '@/hooks/useStore.js';
import './index.less';
const initialState = {
  planDataSource: [],
  healthGuaranteeDuty: {},
  planItem: {},
  planTitle: [],
  healthGuaranteeTitle: []
};

const PlanPreview = (props = {}) => {
  const {
    visible,
    onTooglePlanModal,
    Render
  } = props;
  const [PLAN_ID] = useStore('PLAN_ID');
  const [store, dispatch] = useReducer((o, n) => _objectSpread(_objectSpread({}, o), n), initialState);
  const {
    planDataSource,
    healthGuaranteeDuty,
    planItem,
    planTitle,
    healthGuaranteeTitle
  } = store;

  const onChangePlan = ({
    value = PLAN_ID
  }, palnData = planDataSource, healthGuaranteeData = healthGuaranteeDuty) => {
    let idx = 0;

    if (value) {
      idx = palnData.findIndex(e => e.value === value);
    }

    if (idx > -1) {
      if (healthGuaranteeData.children) {
        dispatch({
          planItem: healthGuaranteeData.children[1].children[idx].children[0].attrs || {}
        });
      }
    }
  };

  useEffect(() => {
    var _planSelectPreviewDat;

    const planSelect = findModuleFromState((curr = {}) => {
      return curr && curr.component === 'planSelectModule';
    });
    const planSelectPreviewData = ((planSelect === null || planSelect === void 0 ? void 0 : planSelect.children) || []).find(e => e.component === 'planSelect');
    const planDataSourceData = (planSelectPreviewData === null || planSelectPreviewData === void 0 ? void 0 : (_planSelectPreviewDat = planSelectPreviewData.attrs) === null || _planSelectPreviewDat === void 0 ? void 0 : _planSelectPreviewDat.dataSource) || [];
    const healthGuaranteeDutyData = findModuleFromState((curr = {}) => {
      return curr && curr.component === 'healthGuaranteeDutyModule';
    });
    dispatch({
      planDataSource: planDataSourceData,
      healthGuaranteeDuty: healthGuaranteeDutyData,
      planItem: {},
      planTitle: planSelect !== null && planSelect !== void 0 && planSelect.children ? [planSelect === null || planSelect === void 0 ? void 0 : planSelect.children[0]] : [],
      healthGuaranteeTitle: healthGuaranteeDutyData !== null && healthGuaranteeDutyData !== void 0 && healthGuaranteeDutyData.children ? [healthGuaranteeDutyData === null || healthGuaranteeDutyData === void 0 ? void 0 : healthGuaranteeDutyData.children[0]] : []
    });
    onChangePlan({
      value: PLAN_ID
    }, planDataSourceData, healthGuaranteeDutyData);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popup, {
    visible: visible,
    direction: "bottom",
    onMaskClick: () => onTooglePlanModal(false),
    destroy: false,
    mountContainer: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "popup-box-plan"
  }, /*#__PURE__*/React.createElement("div", {
    className: "plan-list"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Render, {
    components: planTitle
  }), /*#__PURE__*/React.createElement(PlanSelectPreview, {
    dataSource: planDataSource,
    onChangePlan: onChangePlan
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Render, {
    components: healthGuaranteeTitle
  }), /*#__PURE__*/React.createElement(InsurancePlanDesc, {
    attrs: planItem
  }))), /*#__PURE__*/React.createElement("div", {
    className: "operate"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn",
    block: true,
    theme: "primary",
    onClick: () => onTooglePlanModal(false)
  }, "\u5173\u95ED")))));
};

export default PlanPreview;